// ps-adv-housing.js — PawShift Housing Survival Advertorial

(function () {
  'use strict';

  var progressBar = document.getElementById('ps-adv-progress');
  var stickyBar   = document.getElementById('ps-adv-sticky');
  var reveal      = document.getElementById('ps-adv-reveal');
  var stickyShown = false;

  function onScroll() {
    var scrollTop  = window.scrollY || document.documentElement.scrollTop;
    var docHeight  = document.documentElement.scrollHeight - window.innerHeight;

    // Reading progress bar
    if (progressBar && docHeight > 0) {
      progressBar.style.width = ((scrollTop / docHeight) * 100) + '%';
    }

    // Sticky bar: show after product reveal section scrolls past viewport
    if (stickyBar && reveal && !stickyShown) {
      var revealBottom = reveal.getBoundingClientRect().bottom;
      if (revealBottom < 0) {
        stickyShown = true;
        stickyBar.classList.add('is-visible');
        stickyBar.removeAttribute('aria-hidden');
      }
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
